import { z } from 'zod'

export const LANGUAGE_CODES = ['ar', 'zh', 'en', 'fa', 'fr', 'hi', 'ja', 'ko', 'pa', 'ru', 'es', 'tl', 'vi'] as const

export const LanguageCodeSchema = z.enum(LANGUAGE_CODES).meta({
  id: 'languageCode',
  title: 'Language Code',
  description: 'ISO 639-1 language code',
})

export type LanguageCode = z.infer<typeof LanguageCodeSchema>

export const LANGUAGE_NAMES: Record<LanguageCode, string> = {
  ar: 'Arabic',
  zh: 'Chinese',
  en: 'English',
  fa: 'Persian',
  fr: 'French',
  hi: 'Hindi',
  ja: 'Japanese',
  ko: 'Korean',
  pa: 'Punjabi',
  ru: 'Russian',
  es: 'Spanish',
  tl: 'Tagalog',
  vi: 'Vietnamese',
}

export function getLanguageName(code: LanguageCode): string {
  return LANGUAGE_NAMES[code]
}

export function isLanguageCode(value: string): value is LanguageCode {
  return LANGUAGE_CODES.some((code) => code === value)
}
